module.exports = __webpack_public_path__ + "static/media/golden_globe.33fc5148.svg";